import SearchResult from "./SearchResult";
import SearchPaginator from "./SearchPaginator";
import React from "react";

export default function SearchResults(props) {
    let resultsDisplay = '';
    if (props.results)
    {
        if (props.results.data.length) {
            resultsDisplay = props.results.data.map((specimen) => {
                return (<SearchResult key={specimen.id} specimen={specimen}/>)
            })
            return (
                <div>
                    <table className={'table'}>
                        <thead>
                        <tr>
                            <th>Catalog Number</th>
                            <th>Taxon Name</th>
                            <th>Common Name</th>
                            <th>Locality Number</th>
                            <th>Case Number</th>
                            <th>Attributes</th>
                        </tr>
                        </thead>
                        <tbody>
                        {resultsDisplay}
                        </tbody>
                    </table>
                    {
                        (props.results.links && props.results.last_page > 1) ?
                            <SearchPaginator results={props.results} loadSearchResultPage={props.loadSearchResultPage}/>
                            : null
                    }
                </div>
            )
        } else {
            return (<p>No results found</p>)
        }
    }
}
